import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetVoucherListRequestDto } from "@/modules/voucher/dtos/get-voucher-list-request-dto";
import type { GetVoucherListResponseDto } from "@/modules/voucher/dtos/get-voucher-list-response-dto";
import { VoucherQueryKeys } from "@/modules/voucher/generators/voucher-query-keys";
import { VoucherService } from "@/modules/voucher/services/voucher-service";

type UseGetVouchersQueryProps = {
  queryParams: GetVoucherListRequestDto;
  options?: Omit<UseQueryOptions<GetVoucherListResponseDto>, "queryKey">;
};

export const useGetVoucherListQuery = ({
  queryParams,
  options
}: UseGetVouchersQueryProps) => {
  return useQuery({
    queryKey: VoucherQueryKeys.getVoucherList({ ...queryParams }).queryKey,
    queryFn: async () =>
      await VoucherService.getVoucherList({ payload: queryParams }),
    ...options
  });
};
